<forge-label-value [inline]="isInline" [ngStyle]="alignment" [ngClass]="{'full': !isInline}">
    <div slot="label">{{label}}</div>
    <span *ngIf="!boolean" slot="value">
        <truncate-text *ngIf="!loading" [mainText]="value" class="metadata-label-value--value">
        </truncate-text>
    </span>
    <span *ngIf="boolean && !loading" slot="value">
        <forge-icon [hidden]="!showCheck" name="check" class="grid-icon"></forge-icon>
    </span>
</forge-label-value>
